import { ShapeList } from "../interface/flow-builder.interface";

export const ApiStatus={
  ok:'success',
  failed: 'failed'
}

export const nodeType = {
  sources: 'Read/Write',
  source: 'Source',
  target: 'Destination',
  filter: 'Filter',
  transform: 'Transform',
  join_: 'JOIN',
  join: 'Join',
  select: 'Select',
  dataCleaning: 'Data Cleaning',
  aggregate: 'Aggregate',
  formula: 'Formula',
  sort: 'Sort',
  append:'Append',
  script:'Script',
  python: 'Python',
  bash: 'Bash',
  sql: 'SQL'

};

export const VisualizationType = [
  'Chart',
  'Geo-Chart',
  'Table',
  'KPI Card'
]

export enum ActiveType {
  default = 'default',
  import = 'import',
  connectionList = 'connection list',
  selectTable = 'Select Table',
  mapData = 'Map Data',
  validateData = 'Validate Data'
}

export const sidebarList: ShapeList[] = [
  {
    id: 1,
    name: nodeType.sources,
    icon: '/assets/images/svg/menu-1.svg',
    isOpen:true,
    submenu: [{
      inputs: 0,
      outputs: 1,
      name: nodeType.source,
      icon: '/assets/images/svg/sub-menu-2.svg',
      iconSelected: '/assets/images/svg/upload-outline.svg',
      },
      {
        inputs: 1,
        outputs: 0,
        name: nodeType.target,
        icon: '/assets/images/svg/download-outline.svg',
      },
    ],
  },
  {
    id: 2,
    name: nodeType.transform,
    icon: '/assets/images/svg/3d-cube.svg',
    isOpen:true,
    submenu: [{
      inputs: 1,
      outputs: 1,
      name: nodeType.select,
      icon: '/assets/images/svg/select.svg',
    },
    {
      inputs: 1,
      outputs: 2,
      name: nodeType.filter,
      icon: '/assets/images/svg/filter.svg'
    },
    {
      inputs: 1,
      outputs: 2,
      name: nodeType.dataCleaning,
      icon: '/assets/images/svg/data-cleaning.svg'
    },
    {
      inputs: 1,
      outputs: 2,
      name: nodeType.aggregate,
      icon: '/assets/images/svg/agree.svg'
    },
    {
      inputs: 1,
      outputs: 2,
      name: nodeType.sort,
      icon: '/assets/images/svg/sort.svg'
    }

    ]
  },
  {
    id: 3,
    name: nodeType.join,
    icon: '/assets/images/svg/join.svg',
    isOpen:true,
    submenu: [{
      inputs: 2,
      outputs: 3,
      name: nodeType.join,
      icon: 'assets/images/svg/transition.svg'
    },
    {
      inputs: 2,
      outputs: 3,
      name: nodeType.append,
      icon: '/assets/images/svg/append.svg'
    }
    ]
  },
  {
    id: 4,
    name: nodeType.script,
    icon:'assets/images/svg/python.svg',
    isOpen:true,
    submenu: [{
      inputs: 2,
      outputs: 3,
      name: nodeType.python,
      icon: '/assets/images/svg/python_.svg'
    },
    {
      inputs: 2,
      outputs: 3,
      name: nodeType.bash,
      icon: '/assets/images/svg/bash.svg'
    },
    {
      inputs: 2,
      outputs: 3,
      name: nodeType.sql,
      icon: '/assets/images/svg/sql.svg'
    }
    ]
  }

];
export interface IterationSetModel{
  name:string,
  all_columns : any[], 
  target_columns:string[],
  compared_result:any[],
  isNameEdit:boolean,
  isRunLoad:boolean,
  isOpen:boolean,
  isAction:boolean,
  uuid:string,
  color:string,
  satisfy:boolean,
  driversList?:any[],
  scenarioList:any[],
  selectScenarioIndex:number,
  accuracy_data?:any
}

// {
    //   show: true,
    //   toggle: false,
    //   title: 'Transform',
    //   icon: '/assets/images/svg/3d-cube.svg',
    //   url: '',
    //   subTitile: [
    //     {
    //       id: 1,
    //       name: 'Select',
    //       show: false,
    //       url: '',
    //       icon: '/assets/images/svg/select.svg',
    //     },
    //     {
    //       id: 2,
    //       name: 'Filter',
    //       show: true,
    //       url: '',
    //       icon: '/assets/images/svg/filter.svg',
    //     },
    //     {
    //       id: 3,
    //       name: 'Data Cleaning',
    //       show: true,
    //       url: '',
    //       icon: '/assets/images/svg/data-cleaning.svg',
    //     },
    //     {
    //       id: 4,
    //       name: 'Aggregate',
    //       show: true,
    //       url: '',
    //       icon: '/assets/images/svg/agree.svg',
    //     },
    //     {
    //       id: 5,
    //       name: 'Sort',
    //       show: true,
    //       url: '',
    //       icon: '/assets/images/svg/sort.svg',
    //     },
    //   ],
    // },
    // {
    //   show: true,
    //   toggle: false,
    //   title: 'Join',
    //   icon: '/assets/images/svg/3d-cube.svg',
    //   url: '',
    //   subTitile: [
    //     {
    //       id: 1,
    //       name: 'Join',
    //       show: false,
    //       url: '',
    //       icon: '/assets/images/svg/join.svg',
    //     },
    //     {
    //       id: 2,
    //       name: 'Append',
    //       show: true,
    //       url: '',
    //       icon: '/assets/images/svg/append.svg',
    //     },
    //   ],
    // },
    // {
    //   show: true,
    //   toggle: false,
    //   title: 'Script',
    //   icon: '/assets/images/svg/script.svg',
    //   url: '',
    //   subTitile: [
    //     {
    //       id: 1,
    //       name: 'Python',
    //       show: false,
    //       url: '',
    //       icon: '/assets/images/svg/python.svg',
    //     },
    //     {
    //       id: 2,
    //       name: 'Bash',
    //       show: true,
    //       url: '',
    //       icon: '/assets/images/svg/bash.svg',
    //     },
    //     {
    //       id: 2,
    //       name: 'SQL',
    //       show: true,
    //       url: '',
    //       icon: '/assets/images/svg/sql.svg',
    //     },
    //   ],
    // },
